export const incoterms = {
  cfr: "CFR",
  cif: "CIF",
  cpt: "CPT",
  cip: "CIP",
  dpu: "DPU",
  dap: "DAP",
  ddp: "DDP",
  exw: "EXW",
  fca: "FCA",
  fas: "FAS",
  fob: "FOB",
};

export const incotermsList = Object.keys(incoterms);
